import createHostComponent from '../../createHostComponent';
var Label = createHostComponent('label', { htmlFor: 'for' });
export default Label;
